import { attentionColors } from "../themes/mobiliTheme";
import { generateColor } from "./generateColor";

export const backgroundColourCheck = (differenceInWeeksValue: number) => {
  let backgroundColor = "";
  if (differenceInWeeksValue <= 1) {
    backgroundColor = attentionColors.customInfoPrimary;
  } else if (differenceInWeeksValue <= 2) {
    backgroundColor = attentionColors.lowPriority; // Add your color for <= 2 weeks
  } else if (differenceInWeeksValue <= 3) {
    backgroundColor = attentionColors.highPriority; // Add your color for <= 3 weeks
  } else {
    backgroundColor = attentionColors.immediateAttention; // Add your color for > 3 weeks
  }
  // console.log("backgroundColourCheck", backgroundColor, differenceInWeeksValue);
  return backgroundColor;
};

// Mirrors the backend validation rule (gaps.maxDaysBetweenConsecutiveAppointments)
export const MAX_GAP_DAYS = 14;

// Pink: gap is too long but has a justification (red is reserved for unjustified)
export const justifiedGapColor = "#e879ab";

/**
 * Two-dimensional gap color: encodes both gap length and justification status.
 * - within limit: info (<= 1 week) / warning yellow (<= MAX_GAP_DAYS)
 * - too long + justified: pink
 * - too long + unjustified: red
 */
export const gapColourCheck = (gapInDays: number, justified: boolean) => {
  if (gapInDays <= 7) {
    return attentionColors.customInfoPrimary;
  }
  if (gapInDays <= MAX_GAP_DAYS) {
    return attentionColors.lowPriority;
  }
  return justified ? justifiedGapColor : attentionColors.immediateAttention;
};

const rxNumberColorMap: { [key: string]: string } = {};

export const getColorForRxNumber = (rxNumber: string) => {
  // Check if the color for this Rx number is already assigned
  if (rxNumberColorMap[rxNumber]) {
    return rxNumberColorMap[rxNumber];
  }

  // If not assigned, generate a new color using the generateColor function
  const newColor = generateColor(rxNumber);
  rxNumberColorMap[rxNumber] = newColor;
  // console.log("NEWCOLO", newColor);
  return newColor;
};
